import { useCallback, useEffect, useRef, useState } from 'react';
import { getApiHeaders } from '../../../utils/apiHelpers';
import { haccpApi } from '../haccpApi';

const URL_CHIEDI = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/haccp/assistente/chiedi`;
let contatore = 0;

// Legge la risposta SSE pezzo per pezzo: {t} testo, {fine, fonti, norma}, {errore}
const leggiFlusso = async (risposta, onEvento) => {
  const lettore = risposta.body.getReader();
  const dec = new TextDecoder();
  let resto = '';
  for (;;) {
    const { value, done } = await lettore.read();
    if (done) return;
    resto += dec.decode(value, { stream: true });
    const blocchi = resto.split('\n\n');
    resto = blocchi.pop();
    blocchi.forEach((b) => { if (b.startsWith('data: ')) onEvento(JSON.parse(b.slice(6))); });
  }
};

// Scelta utente: la conversazione resta solo qui sul telefono e sparisce chiudendo
export const useAssistente = () => {
  const [messaggi, setMessaggi] = useState([]);
  const [stato, setStato] = useState(null);
  const timer = useRef(null);
  const aggiorna = (id, f) => setMessaggi((m) => m.map((x) => (x.id === id ? { ...x, ...f(x) } : x)));
  const caricaStato = useCallback(async () => {
    clearTimeout(timer.current);
    try {
      const s = await haccpApi.get('/assistente/stato');
      setStato(s);
      if (s.in_corso) timer.current = setTimeout(caricaStato, 5000);
    } catch { setStato({ errore: true }); }
  }, []);
  useEffect(() => { caricaStato(); return () => clearTimeout(timer.current); }, [caricaStato]);

  const invia = async (domanda, foto) => {
    const storia = messaggi.filter((m) => !m.errore && m.testo).slice(-12)
      .map((m) => ({ ruolo: m.ruolo, testo: (m.foto ? '(con foto) ' : '') + m.testo }));
    const id = ++contatore;
    setMessaggi((m) => [...m, { id: `u${id}`, ruolo: 'utente', testo: domanda, foto }, { id: `a${id}`, ruolo: 'assistente', testo: '', inCorso: true }]);
    try {
      const r = await fetch(URL_CHIEDI, { method: 'POST', headers: { ...getApiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ domanda, storia, foto: foto ? foto.split(',')[1] : null }) });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(typeof d.detail === 'string' ? d.detail : 'Domanda non inviata: riprova');
      }
      await leggiFlusso(r, (ev) => {
        if (ev.t) aggiorna(`a${id}`, (x) => ({ testo: x.testo + ev.t }));
        if (ev.fine) aggiorna(`a${id}`, () => ({ inCorso: false, fonti: ev.fonti, norma: ev.norma }));
        if (ev.errore) aggiorna(`a${id}`, () => ({ inCorso: false, errore: ev.errore }));
      });
      aggiorna(`a${id}`, () => ({ inCorso: false }));
    } catch (e) {
      aggiorna(`a${id}`, () => ({ inCorso: false, errore: e.message || 'Domanda non inviata: riprova' }));
    }
  };
  const occupato = messaggi.some((m) => m.inCorso);
  return { messaggi, stato, invia, occupato, nuova: () => setMessaggi([]) };
};
